import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedinIn, FaFacebookF, FaInstagram, FaXTwitter, FaYoutube } from 'react-icons/fa6';

const footerLinks = {
  product: [
    { label: 'Home', to: '/' },
    { label: 'Public User Manual', to: '/user-manual' },
    { label: 'Learn More', to: '/learn-more' },
  ],
  support: [
    { label: 'Support', to: '/support' },
    { label: 'Privacy Policy', to: '/privacy-policy' },
    { label: 'Cookies Policy', to: '/cookies-policy' },
    { label: 'Terms & Conditions', to: '/terms' },
    { label: 'Disclaimer', to: '/disclaimer' },
    { label: 'Email: admin@putpens.com', href: 'mailto:admin@putpens.com' },
  ],
};

const socials = [
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/uniq-loop-technologies-llc/?viewAsMember=true', icon: FaLinkedinIn },
  { label: 'Facebook', href: 'https://www.facebook.com/share/18d9gSW4By/?mibextid=wwXIfr', icon: FaFacebookF },
  { label: 'Instagram', href: 'https://www.instagram.com/uniqloopiiotai?igsh=N2k5ZWxiNGVoNHN4', icon: FaInstagram },
  { label: 'X', href: 'https://x.com/uniqloopiiot?s=21', icon: FaXTwitter },
  { label: 'YouTube', href: 'https://youtube.com/@uniqloopiiotai?si=H-KERwn-1VFQKk3Q', icon: FaYoutube },
];

const Section = ({ title, items }) => (
  <div>
    <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-purple-200">{title}</h3>
    <ul className="mt-4 space-y-3">
      {items.map((item) => (
        <li key={item.to || item.href}>
          {item.href ? (
            <a href={item.href} className="text-lg text-purple-50 transition hover:text-white">
              {item.label}
            </a>
          ) : (
            <Link to={item.to} className="text-lg text-purple-50 transition hover:text-white">
              {item.label}
            </Link>
          )}
        </li>
      ))}
    </ul>
  </div>
);

const SiteFooter = () => (
  <footer className="relative overflow-hidden bg-[#1b0a43] text-white">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_18%,rgba(174,120,255,0.35),transparent_38%),radial-gradient(circle_at_85%_72%,rgba(110,63,214,0.36),transparent_45%)]" />
    <div className="relative mx-auto w-full max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-7 border-b border-white/20 pb-10 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h2 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">Stay with us on social</h2>
        </div>
        <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center">
          <span className="text-sm font-semibold uppercase tracking-[0.35em] text-purple-200">Follow Us:</span>
          <div className="flex flex-wrap items-center gap-3">
            {socials.map(({ label, href, icon: Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="flex h-12 w-12 items-center justify-center rounded-full border border-white/40 text-white transition hover:border-white hover:bg-white/10 hover:text-white"
              >
                <Icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="grid gap-10 border-b border-white/20 py-10 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr]">
        <div className="max-w-sm">
          <div className="flex items-center gap-3">
            <img src="/images/putpens-logo-new.png" alt="PutPens logo" className="h-11 w-11 rounded-xl bg-white p-2" />
            <p className="text-5xl font-semibold tracking-tight text-white">PutPens</p>
          </div>
          <p className="mt-5 text-lg leading-relaxed text-purple-100">
            PutPens is a smart workforce management platform employee operations, and team productivity.
          </p>
        </div>
        <Section title="Product" items={footerLinks.product} />
        <Section title="Support" items={footerLinks.support} />
      </div>

      <div className="flex flex-col gap-3 pt-8 text-base text-purple-100 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-purple-100">© 2026 PutPens. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
